module.exports = __webpack_public_path__ + "img/jpBanner1.e674ed5a.png";